module.exports = __webpack_public_path__ + "static/media/02_blanco.e4027edb.svg";